import {ActionBuilder} from "co-redux-builders";

export default ActionBuilder.build({
    setCheckedIds: (currentId: string) => ({currentId}),
    clearReducer: () => ({}),
});